import Swiper, { Navigation, Pagination } from 'swiper';
import $ from 'jquery';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

function initBlockWithSeparatedCarouselAndTabs() {
  const keyCodesAvailable = [undefined, 1, 13, 32];
  document.querySelectorAll('.location-carousel').forEach((slider) => {
    const sliderContainers = slider.querySelectorAll('.location-carousel__swiper-container');
    Array.from(sliderContainers).forEach((container) => {
      // eslint-disable-next-line no-new
      new Swiper(container, {
        slidesPerView: 3,
        spaceBetween: 30,
        autoHeight: true,
        modules: [Navigation, Pagination, HideOffscreenSlides],
        speed: 700,
        navigation: {
          nextEl: container.querySelector('.location-carousel__nav--next'),
          prevEl: container.querySelector('.location-carousel__nav--prev'),
        },
        pagination: {
          el: container.querySelector('.location-carousel__swiper-pagination'),
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
        },
      });

      const sliderTabsInside = slider.querySelectorAll('.location-carousel__name');
      const sliderTabsWrapper = slider.querySelector('.location-carousel__tabs');
      const blockId = slider.id;

      for (let i = 0; i < sliderTabsInside.length; i++) {
        const newTab = document.createElement('li');
        newTab.classList.add('location-carousel__tab');
        newTab.setAttribute('data-index', i);
        newTab.setAttribute('id', `${blockId}-tab-${i}`);
        newTab.setAttribute('role', 'tab');
        newTab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        newTab.setAttribute('aria-controls', `${blockId}-panel-${i}`);
        newTab.setAttribute('tabindex', i === 0 ? 0 : -1);
        newTab.textContent = sliderTabsInside[i].textContent;
        sliderTabsWrapper.append(newTab);

        if (newTab.textContent <= 0) {
          newTab.classList.add('location-carousel__tab--empty');
        }

        sliderTabsInside[i].remove();
      }

      const sliderTabs = slider.querySelectorAll('.location-carousel__tab');

      function activateTab(newIndex) {
        sliderTabs.forEach((elem) => {
          const isActive = Number(elem.dataset.index) === Number(newIndex);
          elem.classList.toggle('active', isActive);
          elem.setAttribute('aria-selected', String(isActive));
          elem.setAttribute('tabindex', isActive ? 0 : -1);
        });
        // eslint-disable-next-line no-return-assign,no-param-reassign
        sliderContainers.forEach((elem) => elem.style.display = 'none');
        document.querySelector(`.location-carousel__swiper-container--${Number(newIndex) + 1}`).style.display = 'block';
      }

      for (let i = 0; i < sliderTabs.length; i++) {
        sliderTabs[0].classList.add('active');

        $(sliderTabs[i]).on('click keyup', (event) => {
          if (keyCodesAvailable.indexOf(event.keyCode) !== -1) {
            activateTab(i);
          }
        });

        sliderTabs[i].addEventListener('keydown', (event) => {
          const totalTabs = sliderTabs.length;
          const currentIndex = Number(sliderTabs[i].dataset.index);
          let newIndex;

          switch (event.key) {
            case 'ArrowRight':
              newIndex = (currentIndex + 1) % totalTabs;
              break;
            case 'ArrowLeft':
              newIndex = (currentIndex - 1 + totalTabs) % totalTabs;
              break;
            case 'Home':
              newIndex = 0;
              break;
            case 'End':
              newIndex = totalTabs - 1;
              break;
            default:
              return;
          }

          event.preventDefault();
          activateTab(newIndex);
          sliderTabs[newIndex].focus();
        });
      }
    });
  });
}

$(window).on('load resize', () => {
  initBlockWithSeparatedCarouselAndTabs();
});
